var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"home"},[_c('title-block'),_c('subtitle-block'),_c('channels-block'),_c('demo-block'),_c('footer-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }